import './Pricing.css';
function Pricing() {
  return (
    <div className='pricing-tables-section'>
        <div className='pricing-tables-section-tables'>
          <div className='pricing-tables-section-tables-one'>
            <h1>basic</h1>
            <h2>$ 39.99</h2>
            <span>a basic plan for payment without any stress</span>
            <svg
                x="0px"
                y="0px"
                width="65px"
                height="3px"
                viewBox="0 0 65 3"
                enable-background="new 0 0 65 3"
            >
                <g>
                    <polygon class="edgtf-polygon edgtf-polygon-1" points="0,0 16.021,0 12.958,3 0,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-2" points="16.268,3 19.299,0 29.562,0 26.5,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-3" points="29.969,3 33,0 40,0 37.031,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-4" points="41.031,3 44,0 49.031,0 46.031,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-5" points="50.969,3 54.031,0 58.031,0 55,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-6" points="59.96,3 62.96,0 65,0 61.992,3" fill="#171717" />
                </g>
            </svg>
            <div className='pricing-tables-section-tables-one-list'>
              <ul>
                <li><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#171717"><path d="M268-240 42-466l57-56 170 170 56 56-57 56Zm226 0L268-466l56-57 170 170 368-368 56 57-424 424Zm0-226-57-56 198-198 57 56-198 198Z"/></svg>a basic plan for payment</li>
                <li><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#171717"><path d="M268-240 42-466l57-56 170 170 56 56-57 56Zm226 0L268-466l56-57 170 170 368-368 56 57-424 424Zm0-226-57-56 198-198 57 56-198 198Z"/></svg>contracts and new orders</li>
                <li><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#171717"><path d="M268-240 42-466l57-56 170 170 56 56-57 56Zm226 0L268-466l56-57 170 170 368-368 56 57-424 424Zm0-226-57-56 198-198 57 56-198 198Z"/></svg>strategy and marketing</li>
              </ul>
            </div>
            <a href='/'>buy now</a>
          </div>
          <div className='pricing-tables-section-tables-two'>
            <h1>standard</h1>
            <h2>$ 59.99</h2>
            <span>an ordinary plan for payment without any stress</span>
            <svg
                x="0px"
                y="0px"
                width="65px"
                height="3px"
                viewBox="0 0 65 3"
                enable-background="new 0 0 65 3"
            >
                <g>
                    <polygon class="edgtf-polygon edgtf-polygon-1" points="0,0 16.021,0 12.958,3 0,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-2" points="16.268,3 19.299,0 29.562,0 26.5,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-3" points="29.969,3 33,0 40,0 37.031,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-4" points="41.031,3 44,0 49.031,0 46.031,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-5" points="50.969,3 54.031,0 58.031,0 55,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-6" points="59.96,3 62.96,0 65,0 61.992,3" fill="#171717" />
                </g>
            </svg>
            <div className='pricing-tables-section-tables-one-list'>
              <ul>
                <li><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#171717"><path d="M268-240 42-466l57-56 170 170 56 56-57 56Zm226 0L268-466l56-57 170 170 368-368 56 57-424 424Zm0-226-57-56 198-198 57 56-198 198Z"/></svg>a basic plan for payment</li>
                <li><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#171717"><path d="M268-240 42-466l57-56 170 170 56 56-57 56Zm226 0L268-466l56-57 170 170 368-368 56 57-424 424Zm0-226-57-56 198-198 57 56-198 198Z"/></svg>contracts and new orders</li>
                <li><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#171717"><path d="M268-240 42-466l57-56 170 170 56 56-57 56Zm226 0L268-466l56-57 170 170 368-368 56 57-424 424Zm0-226-57-56 198-198 57 56-198 198Z"/></svg>strategy and marketing</li>
              </ul>
            </div>
            <a href='/'>buy now</a>
          </div>
          <div className='pricing-tables-section-tables-three'>
            <h1>premium</h1>
            <h2>$ 89.99</h2>
            <span>an upgrade plan for payment without any stress</span>
            <svg
                x="0px"
                y="0px"
                width="65px"
                height="3px"
                viewBox="0 0 65 3"
                enable-background="new 0 0 65 3"
            >
                <g>
                    <polygon class="edgtf-polygon edgtf-polygon-1" points="0,0 16.021,0 12.958,3 0,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-2" points="16.268,3 19.299,0 29.562,0 26.5,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-3" points="29.969,3 33,0 40,0 37.031,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-4" points="41.031,3 44,0 49.031,0 46.031,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-5" points="50.969,3 54.031,0 58.031,0 55,3" fill="#171717" />
                    <polygon class="edgtf-polygon edgtf-polygon-6" points="59.96,3 62.96,0 65,0 61.992,3" fill="#171717" />
                </g>
            </svg>
            <div className='pricing-tables-section-tables-one-list'>
              <ul>
                <li><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#171717"><path d="M268-240 42-466l57-56 170 170 56 56-57 56Zm226 0L268-466l56-57 170 170 368-368 56 57-424 424Zm0-226-57-56 198-198 57 56-198 198Z"/></svg>a basic plan for payment</li>
                <li><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#171717"><path d="M268-240 42-466l57-56 170 170 56 56-57 56Zm226 0L268-466l56-57 170 170 368-368 56 57-424 424Zm0-226-57-56 198-198 57 56-198 198Z"/></svg>contracts and new orders</li>
                <li><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#171717"><path d="M268-240 42-466l57-56 170 170 56 56-57 56Zm226 0L268-466l56-57 170 170 368-368 56 57-424 424Zm0-226-57-56 198-198 57 56-198 198Z"/></svg>strategy and marketing</li>
              </ul>
            </div>
            <a href='/'>buy now</a>
          </div>
        </div>
    </div>
  );
}

export default Pricing;
